// Explore dropdown carousel: 3 cards in view, auto-scrolls left, then back right every 5s.
const INTERVAL_MS = 5000;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const getTrack = (carousel) => carousel.querySelector('[data-explore-track]');
const maxScroll = (track) => track.scrollWidth - track.clientWidth;

function isOpen(carousel) {
  const item = carousel.closest('.menu-list__list-item');
  return !!item && !!item.querySelector('[aria-expanded="true"]') && carousel.offsetWidth > 0;
}

function updateState(carousel) {
  const track = getTrack(carousel);
  if (!track) return;
  carousel.classList.toggle('is-scrollable', maxScroll(track) > 4);
}

function goTo(carousel, toEnd) {
  const track = getTrack(carousel);
  if (!track || maxScroll(track) <= 4) return;
  track.scrollTo({ left: toEnd ? maxScroll(track) : 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
}

// Hold and drag to scroll; snaps to the nearest card on release.
let drag = null;

document.addEventListener('pointerdown', (event) => {
  if (event.button !== 0) return;
  const track = event.target.closest?.('[data-explore-track]');
  if (!track || maxScroll(track) <= 4) return;
  drag = { track, startX: event.clientX, startScroll: track.scrollLeft, moved: false, pointerId: event.pointerId };
});

document.addEventListener('pointermove', (event) => {
  if (!drag) return;
  const dx = event.clientX - drag.startX;
  if (!drag.moved && Math.abs(dx) < 5) return;
  if (!drag.moved) {
    drag.moved = true;
    drag.track.classList.add('is-dragging');
    drag.track.style.scrollBehavior = 'auto';
    drag.track.setPointerCapture?.(drag.pointerId);
  }
  drag.track.scrollLeft = drag.startScroll - dx;
});

function endDrag() {
  if (!drag) return;
  const { track, moved } = drag;
  drag = null;
  if (!moved) return;
  track.classList.remove('is-dragging');
  track.style.scrollBehavior = '';
  const card = track.querySelector('.header-explore-menu__item');
  const step = card ? card.offsetWidth + (parseFloat(getComputedStyle(track).columnGap) || 0) : 0;
  if (step) {
    const target = Math.min(maxScroll(track), Math.round(track.scrollLeft / step) * step);
    track.scrollTo({ left: target, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }
  // Restart the auto-scroll timer; direction follows where the user left it
  const carousel = track.closest('[data-explore-carousel]');
  if (carousel) {
    lastMove.set(carousel, Date.now());
    toEnd.set(carousel, track.scrollLeft < maxScroll(track) / 2);
  }
}
document.addEventListener('pointerup', endDrag);
document.addEventListener('pointercancel', endDrag);
document.addEventListener('dragstart', (event) => {
  if (event.target.closest?.('[data-explore-track]')) event.preventDefault();
});

// Per-carousel: once open, wait 5s then scroll left (to the end), 5s later scroll right (back), alternating.
const lastMove = new WeakMap(); // timestamp of open / last auto-scroll; absent while closed
const toEnd = new WeakMap();

setInterval(() => {
  if (reduceMotion.matches) return;
  const now = Date.now();
  document.querySelectorAll('[data-explore-carousel]').forEach((carousel) => {
    const track = getTrack(carousel);
    if (!isOpen(carousel)) {
      if (lastMove.has(carousel)) {
        // Reset so each opening starts from the first card
        track?.scrollTo({ left: 0, behavior: 'auto' });
        lastMove.delete(carousel);
      }
      return;
    }
    if (!lastMove.has(carousel)) {
      lastMove.set(carousel, now);
      toEnd.set(carousel, true);
      updateState(carousel);
      return;
    }
    if (now - lastMove.get(carousel) < INTERVAL_MS) return;
    const next = toEnd.get(carousel);
    goTo(carousel, next);
    toEnd.set(carousel, !next);
    lastMove.set(carousel, now);
  });
}, 250);

window.addEventListener('resize', () => {
  document.querySelectorAll('[data-explore-carousel]').forEach(updateState);
});
document.addEventListener('pointerenter', (event) => {
  const carousel = event.target.closest?.('[data-explore-carousel]');
  if (carousel) updateState(carousel);
}, true);
